import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DayEditDialogForm.html?raw';
import on from 'dojo/on';
import locale from 'dojo/date/locale';
import ColorPalette from 'dijit/ColorPalette';
import "dijit/ColorPalette";

import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import "../../../moreCore/UI/NumberInput/NumberInput";
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import "../../../moreCore/UI/DateInput/DateInput";
import DayRow from '../DayRow/DayRow';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import MonthColumnPlanGroupView from '../MonthColumnPlanGroupEditor/MonthColumnPlanGroupView';
import ColorPicker from '../../../moreCore/UI/ColorPicker/ColorPicker';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';

interface _groupRegistryObj {
	group: MCP_group,
	days?: MdsLax<InstanceType<typeof DayRow>>[],
	color?: string,
	proiority?: number,
	concurrentGroups?: number
	appointments?: Array<{ appointment: MCP_appointment, day: MdsLax<InstanceType<typeof DayRow>> }>
}
class DayEditDialogForm extends compose(_WidgetBaseSP) {
	/*
	Dieses Widget wird Angezeigt im Terminoflex/Monatsplaner wenn man auf den Edit-Button auf einem Frei-Text Termin clickt
	*/
	templateString: any = template;

	_createGroupContainer: HTMLElement;
	_moveContainer: HTMLElement;
	_groupContainer: HTMLElement;
	_newGroupButton: HTMLButtonElement;
	_moveGroupButton: HTMLButtonElement;
	_colorPickerContainer: HTMLElement = null;

	_dayEditTextArea: HTMLTextAreaElement = null;
	_groupSelect: MdsLax<InstanceType<typeof SearchSelect>> = null;
	_colorPicker: MdsLax<InstanceType<typeof ColorPalette>> = null;
	_groupNameInput: MdsLax<InstanceType<typeof Edit>> = null;
	_pickColorButton: MdsLax<InstanceType<typeof Edit>> = null;
	_moveSubjectSelect: MdsLax<InstanceType<typeof SelectBox>> = null;
	_movingDirectionInput: MdsLax<InstanceType<typeof SelectBox>> = null;
	_daysNumberToMoveInput: MdsLax<InstanceType<typeof NumberInput>> = null;
	_dateToMoveInput: MdsLax<InstanceType<typeof DateInput>> = null;

	strDayDate: string;
	dayDate: Date;
	appointment: MCP_appointment;
	_actualTextAreaValue: string = "";
	groupNameBeforeEdit: string = null;

	_moveSubject_value: string = null;
	_movingDirection_value: string = null;
	_daysNumberToMove_value: number = null;
	_dateToMove_value: Date = null;

	newGroupButtonIcon: HTMLElement;

	groupEditBtn:HTMLButtonElement;

	_currentlyModifiedAppointment: MCP_currentlyModifiedAppointment;

	myGenericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

	_allGroups: Array<{ ID: string, label: string }> = [];
	_dayEditDialogControls = [(this as any)._dayEditTextArea, (this as any)._groupSelect, (this as any)._groupNameInput, (this as any)._pickColorButton, (this as any)._colorPicker, (this as any)._moveSubjectSelect, (this as any)._daysNumberToMoveInput, (this as any)._movingDirectionInput, (this as any)._dateToMoveInput];
	groupSelectOptions: Array<{ label: string, value: string }> = []; //Array<{label: group.label, value: group.ID}> (group descriptions);
	_groupRegistry: Array<_groupRegistryObj> = [];

	defaultGroupTextPlaceholder = "DefaultGroup"; //wird im construktur zur translation gesetzts

	colorPickerForOverWriteColor:MdsLax<InstanceType<typeof ColorPicker>>;

	overWriteColorCheckBox:MdsLax<InstanceType<typeof CheckBox>>;
	overWriteColorCheckBoxContainer:HTMLDivElement;

	fallBackPrimaryColor = "#000";
	fallBackSecondaryColor = "#fff";
	setOverWriteColor = false;

	/// Methods -----------------------------------------------------

	_isDarkColor(hexValue: string): boolean {
		let color: string;

		if (hexValue.indexOf("#") != 1) color = hexValue.substring(1); // strip #  

		if (color.length > 6) color = color.slice(0, 7); // strip opacity

		let rgb = parseInt(color, 16); // convert rrggbb to decimal  

		let r = (rgb >> 16) & 0xff; // extract red  
		let g = (rgb >> 8) & 0xff; // extract green  
		let b = (rgb >> 0) & 0xff; // extract blue

		var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

		if (luma < 125) { // luma value range is 0..255, where 0 is the darkest and 255 is the lightest  
			return true;
		} else {
			return false;
		}
	}

	_onkeyUpDayEditTextArea(evt: KeyboardEvent): void {
		if (this._currentlyModifiedAppointment) {
			this._actualTextAreaValue = this._dayEditTextArea.value;
			this._currentlyModifiedAppointment["text"] = this._dayEditTextArea.value;
		}
	}

	_onchange_groupSelect(evt?: Event): void {


		if (this._currentlyModifiedAppointment && this._currentlyModifiedAppointment.group) {

			let selectOption = this._groupSelect.getValue(true);
			if (this.defaultGroupTextPlaceholder == selectOption["value"]){
				selectOption = undefined;
			}
			
			if (typeof selectOption != 'undefined'){
				if (selectOption != null) {
					if (selectOption && selectOption.value != this.defaultGroupTextPlaceholder) {
						this._currentlyModifiedAppointment.group.ID = selectOption.value;
						this._currentlyModifiedAppointment.group.description = selectOption.label;
					}

					if (selectOption.value.length && selectOption.value != this.defaultGroupTextPlaceholder) {

						for (let groupObj of this._groupRegistry) {
							if (groupObj.group.ID == selectOption.value) {

								this._currentlyModifiedAppointment.primaryColor = groupObj.group.primaryColor;
								this._currentlyModifiedAppointment.group.primaryColor = groupObj.group.primaryColor;

								this._currentlyModifiedAppointment.secondaryColor = groupObj.group.secondaryColor;
								this._currentlyModifiedAppointment.group.secondaryColor = groupObj.group.secondaryColor;


								if (this._colorPicker != null && typeof this._colorPicker != "undefined" && this._colorPicker._destroyed != true) {
									this._colorPicker.set("value", "#" + groupObj.group.primaryColor);
								}
							}
						}

						this._currentlyModifiedAppointment.group.ID = selectOption.value;
					}
			}
			} else {
				this._currentlyModifiedAppointment.group.ID = null;
				this._currentlyModifiedAppointment.primaryColor = null;
				this._currentlyModifiedAppointment.group.description = null;
			}

		}

		this._dayEditDialog_processGroupSelection();
	}

	_onFocusGroupNameInput(): void {
		this.groupNameBeforeEdit = this._groupNameInput.get("value");
	}
	_onBlurGroupNameInput(): void {
		let value = this._groupNameInput.get("value");

		if (value) {

			for (let groupRegistryObj of this._allGroups) {
				if (groupRegistryObj.label == value) {
					if (this._groupSelect.optionExists(groupRegistryObj.ID)) {
						this._groupSelect.set("value", groupRegistryObj.ID);
					}
				}
			}

			if (this._currentlyModifiedAppointment && this._currentlyModifiedAppointment.group) {
				this._currentlyModifiedAppointment.group.description = value;
			}

			if (value != this.groupNameBeforeEdit) {
				this.emit("dayEditDialogForm/groupPropertiesModified");
			}
		}
	}

	_onBlurPickColorInput(): void {
		let textValue: string = this._pickColorButton.get("value");
		if (textValue) {
			textValue.replace("/[ /,\.-\"\'\\<>]/g", "");

			textValue.trim();

			if (textValue.length <= 9) {
				if (textValue.indexOf('#') == -1) {
					textValue = '#' + textValue;
				}
				// wenn wir jetzt immer noch kein Farbwert haben, dann ist nicht mehr zu helfen

				this._colorPicker.set("value", textValue);
			} else {
				this._colorPicker.set("value", "Invalid value");
			}
		}
	}

	flagGroupToggle = true;
	_onClickNewGroupButton(evt: Event): void {
		this.flagGroupToggle = (!this.flagGroupToggle);
		this.UiModder.domAttr.set(this._moveGroupButton, "disabled", !this.flagGroupToggle);

		// show containers here ...
		if (this.flagGroupToggle == false) {
			this.UiModder.domClass.remove(this._createGroupContainer, "w3-hide");
		} else {
			this.UiModder.domClass.add(this._createGroupContainer, "w3-hide");
		}
		this._dayEditDialog_processGroupSelection()
	}

	flagGroupsWereEdit = false;
	private groupView:MdsLax<InstanceType<typeof MonthColumnPlanGroupView>>;
	
	_onClick_GroupEditorButton(ev: Event) {
		let groupID = this._groupSelect.get('value');
		if (groupID == this.defaultGroupTextPlaceholder){
			return;
		}
		if ((typeof this.groupView != 'undefined') || (this.groupView != null)){
			this.groupView.destroyRecursive();
		}
		this.groupView = new MonthColumnPlanGroupView();
		this.groupView.showAsDlg(groupID);
		this.groupView.getCurrentDlg().on("closed", lang.hitch(this, ()=>{
			setTimeout(lang.hitch(this, () => {
				this.flagGroupsWereEdit = true;
				this.updateGroupData();
				this.emit("groupWasUpdated");
			}),50);
		}));
	}

	onDeleteCurrentGroupID = "";
	_onClickDeleteGroupButton(evt: Event, id?: string): void {


		let groupID: string = null;

		if (id) {
			groupID = id;
		} else {
			groupID = this._groupSelect.get('value');
			if (groupID == this.defaultGroupTextPlaceholder) {
				groupID = null;
			}
		}

		if (groupID) {
			let groupName: string = this._groupSelect.getValue(true).label;
			this.onDeleteCurrentGroupID = groupID;
			let dlg = new GenericDialog();
			dlg.destroyOnClose = true;
			let cont = this.translations["MonthColumnPlan__deleteConfirmMessage_1"] + groupName + this.translations["MonthColumnPlan__deleteConfirmMessage_2"];
			dlg.show(cont, this.translations["MonthColumnPlan__deleteGroupHeaderMsg"], "", "fas fa-exclamation-triangle", 'okcancel', lang.hitch(this, (res) => {
				//1=ok
				if (res > 0) {
					this._onClickDeleteGroupButtonContinue();
				}
			}));

		} else {
			let dlg = new GenericDialog();
			dlg.destroyOnClose = true;
			dlg.open(this.translations["MonthColumnPlan__deleteErrMessage_1"], this.translations["MonthColumnPlan__deleteGroupHeaderMsg"], "", "fas fa-info-circle", 'ok', null);
		}
	}

	_onClickDeleteGroupButtonContinue() {
		this._currentlyModifiedAppointment = null;
		this._dayEditTextArea.value = "";
		this._setLastTextAreaValue("");
		this.emit("dayEditDialogForm/deleteGroup", this.onDeleteCurrentGroupID);
	}

	_onValueChange_moveSubjectSelect(): void {
		this._moveSubject_value = this._moveSubjectSelect.getValue();
		this.emit("dayEditDialogForm/moveSubject_value", this._moveSubject_value);
	}

	flagToggleGroupMove = false;
	_onClickMoveGroupButton(evt: Event): void {
		this.flagToggleGroupMove = (!this.flagToggleGroupMove);

		if (evt !== null) {
			evt.stopPropagation();
		}
		this._moveSubjectSelect.setValue("appointment");

		//this.UiModder.domAttr.set(this._newGroupButton, "disabled", this.flagToggleGroupMove);
		this.UiModder.domAttr.set(this._dayEditTextArea, "disabled", this.flagToggleGroupMove);

		if (this.flagToggleGroupMove == true) {
			this.UiModder.domClass.remove(this._moveContainer, "w3-hide");
			//this.UiModder.domClass.remove(this.groupMoveNotificationContainer, "w3-hide");
		} else {
			this.UiModder.domClass.add(this._moveContainer, "w3-hide");
			//this.UiModder.domClass.add(this.groupMoveNotificationContainer, "w3-hide");
		}
	}

	_onValueChange_daysNumberToMove(): void {
		this._daysNumberToMove_value = this._daysNumberToMoveInput.getValue();
		this.emit("dayEditDialogForm/daysNumberToMove_value", this._daysNumberToMove_value)

		if (this._currentlyModifiedAppointment.ID) {

			let currentApptDate = new Date(this._currentlyModifiedAppointment.date + "T00:00:00");
			let dayDiff = this._movingDirection_value == 'forward' ? Math.abs(this._daysNumberToMove_value) : - Math.abs(this._daysNumberToMove_value);


			// wenn eine Anzahl der Tage oder ein datum angegeben ist
			if (dayDiff != 0) {

				let timeDiff = dayDiff * 1000 * 60 * 60 * 24;

				let dateInputSetValue = new Date(timeDiff + currentApptDate.getTime());

				if (this._dateToMove_value) {
					if (this._dateToMove_value != dateInputSetValue) this._dateToMoveInput.setValue(dateInputSetValue);
				} else {
					this._dateToMoveInput.setValue(dateInputSetValue);
				}

			} else {

				if (this._dateToMove_value) {
					if (this._dateToMove_value != currentApptDate) this._dateToMoveInput.setValue(currentApptDate);
				} else {
					this._dateToMoveInput.setValue(currentApptDate);
				}

			}

		}
	}

	_onValueChange_movingDirectionInput(): void {
		this._movingDirection_value = this._movingDirectionInput.getValue();
		this.emit("dayEditDialogForm/movingDirection_value", this._movingDirection_value);

		if (this._currentlyModifiedAppointment.ID) {

			let currentApptDate: Date = new Date(this._currentlyModifiedAppointment.date + "T00:00:00");
			let dayDiff: number = this._daysNumberToMoveInput.getValue();
			let timeDiff: number;
			let dateInputSetValue: Date;

			if (this._movingDirection_value == "backward") dayDiff = - Math.abs(dayDiff);

			if (dayDiff != null) {
				timeDiff = dayDiff * 1000 * 60 * 60 * 24;

				dateInputSetValue = new Date(timeDiff + currentApptDate.getTime());
				if (this._dateToMove_value) {
					if (this._dateToMove_value != dateInputSetValue) this._dateToMoveInput.setValue(dateInputSetValue);
				} else {
					this._dateToMoveInput.setValue(dateInputSetValue);
				}

			} else {
				if (this._dateToMove_value) {
					if (this._dateToMove_value != currentApptDate) this._dateToMoveInput.setValue(currentApptDate);
				} else {
					this._dateToMoveInput.setValue(currentApptDate);
				}

			}


		}
	}

	_onValueChange_dateToMoveInput(): void {
		this._dateToMove_value = this._dateToMoveInput.getValue();
		this.emit("dayEditDialogForm/dateToMove_value", this._dateToMove_value);

		if (this._dateToMove_value) this._dateToMove_value.setHours(0, 0, 0, 0);

		if (this._currentlyModifiedAppointment.ID && this._dateToMove_value) {


			let currentApptDate: Date = new Date(this._currentlyModifiedAppointment.date + "T00:00:00");
			let dayDiff: number = 0;
			let directionValue: string;
			let dayInputSetValue: number;

			// wenn eine Anzahl der Tage oder ein datum angegeben ist
			if (this._dateToMove_value != currentApptDate) {

				// get the dayDiff from dateInput and currentAppointment Date
				let timeDiff = this._dateToMove_value.getTime() - currentApptDate.getTime();
				dayDiff = timeDiff / 1000 / 60 / 60 / 24;

				directionValue = dayDiff > 0 ? "forward" : "backward";
				dayInputSetValue = Math.abs(dayDiff);

				if (this._daysNumberToMoveInput.getValue() != dayInputSetValue) this._daysNumberToMoveInput.setValue(dayInputSetValue);
				if (this._movingDirectionInput.getValue() != directionValue) this._movingDirectionInput.setValue(directionValue);
			}
		}
	}

	_dayEditDialog_processGroupSelection(): void {

		// checken ob edit oder create:
		let selectedGroup: _groupRegistryObj = null;
		let group_Id: string = this._groupSelect.get("value");
		if (group_Id == this.defaultGroupTextPlaceholder) group_Id = null;
		let foundIt: boolean = false;


		if (this._currentlyModifiedAppointment) { // wenn die Gruppe nicht gelöscht wurde
			if (group_Id) {
				for (let groupObj of this._groupRegistry) {
					if (groupObj.group.ID == group_Id) {
						selectedGroup = groupObj;
						foundIt = true;
					}
				}
			}

			if (selectedGroup) {
				if (this._groupNameInput != null && this._pickColorButton != null && typeof this._groupNameInput != "undefined" && typeof this._pickColorButton != "undefined" && this._groupNameInput._destroyed != true && this._pickColorButton._destroyed != true) {
					this._groupNameInput.set("value", selectedGroup.group.label);
					this._pickColorButton.set("value", "#" + selectedGroup.group.primaryColor);
					this._onBlurPickColorInput();
				}

				//TextArea text of the corresponding appointment setzen
				if (this.appointment && this.appointment.GroupId == selectedGroup.group.ID) {

					this._currentlyModifiedAppointment.ID = this.appointment.ID;
					this._currentlyModifiedAppointment.date = this.appointment["Date"];
					this._currentlyModifiedAppointment["text"] = this.appointment.Description;

					let lastTextValue: string = this.appointment.Description.replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');
					this._dayEditTextArea.value = lastTextValue;
					this._setLastTextAreaValue(lastTextValue);

				}

			}

			// wenn es keine GroupId gibt und dementsprechend keine Gruppe
			if (foundIt == false && this.appointment) {
				//schauen wir ob es gruppenlose appointments gibt



				if (this.appointment && (this.appointment.GroupId == null || this.appointment.GroupId == "")) {

					let lastTextValue: string = this.appointment.Description.replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');
					this._dayEditTextArea.value = lastTextValue;
					this._setLastTextAreaValue(lastTextValue);
					foundIt = true;
					this._currentlyModifiedAppointment["text"] = this.appointment.Description.replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');
				}
			}
		}

		if (foundIt == false) {
			this._dayEditTextArea.value = "";
			this._setLastTextAreaValue("");
		}

		for (let gr of this._allGroups) {
			if (this.appointment.GroupId == gr.ID) {
				if (selectedGroup){
					this._currentlyModifiedAppointment.primaryColor = (gr as any)["primaryColor"];
				}
			}
		}
	}

	_setGroupSelectOptions(): void {

		if (this._allGroups.length) {

			this.groupSelectOptions = [];

			for (let group of this._allGroups) {
				this.groupSelectOptions.push({ label: group.label, value: group.ID });
			}
			this.groupSelectOptions.unshift({ label: this.translations["MonthColumnPlan__groupSelectopitonLabel_noGroupAppt"], value: this.defaultGroupTextPlaceholder });

		}

		if (this._groupSelect && typeof this._groupSelect != "undefined" && this._groupSelect._destroyed != true) {
			this._groupSelect.setSelectionListLEGACY(this.groupSelectOptions);

			if (this._currentlyModifiedAppointment.group && this._currentlyModifiedAppointment.group.ID) {
				this._groupSelect.set("value", this._currentlyModifiedAppointment.group.ID);
				this._onchange_groupSelect();
			} else {
				this._groupSelect.setValue(this.defaultGroupTextPlaceholder);
			}
		}
	}

	updateGroupData() {
		let url: string = window.appRoot + "MonthColumnPlan/GetAllGroups";

		this.RequestManager.post(
			url,
			{
				jsonData: null
			},
			lang.hitch(this, this._onGetAllGroupsResponse),
			lang.hitch(this, function (err) {
				console.error("ERROR: ", err);
			}),
			false // sync
		);
	}

	_onGetAllGroupsResponse(response: Array<MCP_group>): void {
		this._allGroups = response;

		let currentAppointmentHadAGroup = true;
		if (this._currentlyModifiedAppointment.group.ID == null) {
			currentAppointmentHadAGroup = false;
		}
		if (typeof this._currentlyModifiedAppointment.group.ID == 'undefined') {
			currentAppointmentHadAGroup = false;
		}
		if (currentAppointmentHadAGroup) {
			let groupStillExitst = false;
			for (let gr of (this._allGroups as any as Array<MCP_group>)) {
				if (this._currentlyModifiedAppointment.group.ID == gr.ID) {
					groupStillExitst = true;
				}
			}
			if (groupStillExitst == false) {
				this.myGenericDialog.Close();
				return;
			}
		}
		//versuch die farben und gruppen updzudaten
		let lenGR = this._groupRegistry.length;
		for (let i = 0; i <= lenGR; i++) { //crash?
			let elem = this._groupRegistry[i];
			for (let gr of this._allGroups) {
				let wasFound = false;
				if (typeof elem.group != 'undefined') {
					if (elem.group.ID == gr.ID) {
						wasFound = true;
						elem.color = (gr as MCP_group).primaryColor;
						elem.group = gr as MCP_group;
						for (let ap of elem.appointments) {
							ap.appointment.BackColor = (gr as MCP_group).primaryColor;
							ap.appointment.TextColor = (gr as MCP_group).secondaryColor;
						}
					}
				}
				if (wasFound == false) { //neue gruppe -> muss hinzugefuegt werden
					this._groupRegistry.push({
						group: (gr as MCP_group),
						color: (gr as MCP_group).primaryColor,
						days: [],
						proiority: null,
						concurrentGroups: 0,
						appointments: [],
					});
				}
			}
		}
		this._setGroupSelectOptions();
		if (this.flagGroupsWereEdit == false) {
			return;
		}
		this.flagGroupsWereEdit = false;

		let targetSecondaryColor = "";
		let targetPrimaryColor = "";
		//setzt die aktuelle farbe auf das appointment
		for (let gr of this._allGroups) {
			if (this.appointment.GroupId == gr.ID) {
				if (this.setOverWriteColor == false){
					this.appointment.BackColor = "~"+(gr as MCP_group).primaryColor;
					this.appointment.TextColor = "~"+(gr as MCP_group).secondaryColor;
				}
				targetPrimaryColor = (gr as MCP_group).primaryColor;
				targetSecondaryColor = (gr as MCP_group).secondaryColor;
			}
		}
		//setzt overwrite
		if (this.setOverWriteColor == false){
			this.colorPickerForOverWriteColor.setValue(
				{
					txtHex: "#"+targetSecondaryColor,
					bgHex: "#"+targetPrimaryColor
				}
			);
		}
	}


	// Getters && setters ----------------------------------------------
	_setLastTextAreaValue(value: string): void {
		this.emit("dayEditDialogForm/lastTextAreaValueChange", value);
	}
	//----------------------- Lifycycle -------------------------------

	constructor(dayDate: Date, appointment: MCP_appointment, allGroups: Array<{ ID: string, label: string }>, groupRegistryOfTheMonthClone: Array<_groupRegistryObj>) {
        super(...(arguments as unknown as []));
		this.dayDate = dayDate;

		this._allGroups = allGroups;
		this._groupRegistry = groupRegistryOfTheMonthClone;

		// default values
		this._currentlyModifiedAppointment = {
			ID: null,
			"text": null,
			date: this.strDayDate,
			primaryColor: null,
			secondaryColor: "000000",
			group: {
				ID: null,
				description: null,
				primaryColor: null,
				secondaryColor: "000000",
				tooltip: null
			}
		};

		if (appointment) {


			this.appointment = appointment;
			this._currentlyModifiedAppointment.ID = appointment.ID;
			this._currentlyModifiedAppointment["text"] = appointment.Description;
			this._currentlyModifiedAppointment.date = appointment["Date"];

			if (appointment.BackColor) {
				this._currentlyModifiedAppointment.primaryColor = appointment.BackColor;
			}
			if (appointment.GroupId) {
				this._currentlyModifiedAppointment.group.primaryColor = appointment.BackColor;
				this._currentlyModifiedAppointment.group.ID = appointment.GroupId;

			}
			if (appointment.TextColor) { // ist momentan nicht benutzt. später vllt
				this._currentlyModifiedAppointment.secondaryColor = appointment.TextColor;
			}
		}

		//um state fu**ups zu vermeiden wird einfach anhand der aktuellen sprache gesetzt (falls sich sprache irgendwie aendern koennte)
		this.defaultGroupTextPlaceholder = this.translations["MonthColumnPlan__NoGroups_TextPlaceholder"];
	}

	postCreate(): void {
		super.postCreate.apply(this, arguments as any);

		this.strDayDate = locale.format(this.dayDate, {
			selector: "date",
			datePattern: "yyyy-MM-dd"
		});

		if (!this._currentlyModifiedAppointment.date) this._currentlyModifiedAppointment.date = this.strDayDate;

		if (this._currentlyModifiedAppointment["text"]) this._setLastTextAreaValue(this._currentlyModifiedAppointment["text"].replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n'));

		this._setGroupSelectOptions();

		this._moveSubjectSelect.addOption("group", this.translations["MonthColumnPlan__DayEditDlg_move_label_whatToMove_group"], true);
		this._moveSubjectSelect.addOption("appointment", this.translations["MonthColumnPlan__DayEditDlg_move_label_whatToMove_appointment"], true);
		this._moveSubjectSelect.constructOptions();


		this._daysNumberToMoveInput.setValue(0);

		this._movingDirectionInput.addOption("forward", this.translations["MonthColumnPlan__DayEditDlg_move_label_whatToMove_forward"], true);
		this._movingDirectionInput.addOption("backward", this.translations["MonthColumnPlan__DayEditDlg_move_label_whatToMove_back"], true);
		this._movingDirectionInput.constructOptions();
		this._movingDirectionInput.setValue("forward", false);

		if (this._currentlyModifiedAppointment["text"]) this._dayEditTextArea.value = this._currentlyModifiedAppointment["text"].replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');


		on(this._dateToMoveInput.inputNode, "keyUp", lang.hitch(this, "_onValueChange_dateToMoveInput"));
		on(this._dayEditTextArea, "keyup", lang.hitch(this, "_onkeyUpDayEditTextArea"));

		//on(this._groupSelect, "change", lang.hitch(this, this.updateButtonHintsForGroupEdit));

		//this.updateButtonHintsForGroupEdit();
		this._onClickMoveGroupButton(null);
		this._dayEditTextArea.disabled = false;

		this.updateGroupData();
		//workaround fuer falsche anzeige von gruppen
		this._onValueChange_daysNumberToMove();
		this._onValueChange_dateToMoveInput();
		this._onValueChange_moveSubjectSelect();
		this._onValueChange_movingDirectionInput();

		//workaround um dropdown default zu setzen
		setTimeout(lang.hitch(this, () => {
			try {
				this._movingDirectionInput.setValue("forward", false);
			} catch {
				console.warn("unable to set default settings for DayEditDialogForm");
			}
		}), 200);

		this.updateGroupData();
		
		let primColor = this.fallBackPrimaryColor;
		let secColor = this.fallBackSecondaryColor;
		let setOverWriteColor = true;
		
		if (typeof this.appointment.BackColor != 'undefined'){
			if ((this.appointment.BackColor != null) && (this.appointment.BackColor != "")){
				if (this.appointment.BackColor.indexOf("~") == -1){
					//kein ~ im color code
					primColor = "#" + this.appointment.BackColor;
				}else{
					primColor = this.appointment.BackColor.replace("~","");
					setOverWriteColor = false;
				}
			}
		}
		if (typeof this.appointment.TextColor != 'undefined') {
			if ((this.appointment.TextColor != null) && (this.appointment.TextColor != "")) {
				if (this.appointment.TextColor.indexOf("~") == -1) {
					//kein ~ im color code
					secColor = "#" + this.appointment.TextColor;
				} else {
					primColor = this.appointment.TextColor.replace("~", "");
					setOverWriteColor = false;
				}
			}
		}
		//wenn farben gleich sind wie gruppen, overwrite checkbox = false
		let targetGroup = null;
		for (let gr of this._allGroups){
			if (gr.ID == this.appointment.GroupId){
				targetGroup = gr;
			}
		}
		if (targetGroup && typeof targetGroup["primaryColor"] != 'undefined') {
			if (typeof targetGroup["primaryColor"] == 'string') {
				if ((targetGroup["primaryColor"] == this.appointment.BackColor) && (targetGroup["secondaryColor"] == this.appointment.TextColor)) {
					setOverWriteColor = false; //wenn appointment farbe & gruppenfarbe gleich sind, dann wurde nicht ueberschrieben
				}
			}
		}


		this.overWriteColorCheckBox.setValue(setOverWriteColor);
		this.colorPickerForOverWriteColor.setValue({
			txtHex: secColor,
			bgHex: primColor,
		});
		this.flagColorPickerReady = true;


		//events color zeigsl
		this.colorPickerForOverWriteColor.on("change", lang.hitch(this, this._onValueChange_colorPicker));
		this.overWriteColorCheckBox.on("change", lang.hitch(this, this._onValueChange_overWriteColorCheckBox));

		this.setOverWriteColor = setOverWriteColor;

		this._groupSelect.on("change", lang.hitch(this, this._onChange_GroupSelect_DisableEditBtn));
	 }

	 private _onChange_GroupSelect_DisableEditBtn(){
		 let disabledClasses = "disabled w3-disabled".split(" ");
		if (this._groupSelect.getValue() == this.defaultGroupTextPlaceholder){
			this.groupEditBtn.disabled = true;
			for (let cl of disabledClasses){
				if (this.groupEditBtn.classList.contains(cl) == false){
					this.groupEditBtn.classList.add(cl);
				}
			}
		}else{
			this.groupEditBtn.disabled = false;
			for (let cl of disabledClasses) {
				if (this.groupEditBtn.classList.contains(cl) == true) {
					this.groupEditBtn.classList.remove(cl);
				}
			}
		}
	 }

	startup(): void {
		super.startup.apply(this, arguments as any);
	}

	private flagColorPickerReady = false;
	_onValueChange_colorPicker(){
		if (this.flagColorPickerReady == false) {
			return;
		}
		let primColor = this.fallBackPrimaryColor;
		let secColor = this.fallBackSecondaryColor;

		primColor = this.colorPickerForOverWriteColor.getValue('BG');
		secColor = this.colorPickerForOverWriteColor.getValue('TXT');
		primColor = primColor.replace("#", "");
		secColor = secColor.replace("#", "");
		if (this.overWriteColorCheckBox.getValue() == false) {
			primColor = "~"+primColor;
			secColor = "~"+secColor;
		}
		this.appointment.BackColor = primColor;
		this.appointment.TextColor = secColor;
		this._currentlyModifiedAppointment.primaryColor = primColor;
		this._currentlyModifiedAppointment.secondaryColor = secColor;
		this.emit("dayEditDialogForm/color_updated");
		this.emit("dayEditDialogForm/groupPropertiesModified");
	}
	_onValueChange_overWriteColorCheckBox(){
		if (this.overWriteColorCheckBox.getValue() == true) {
			if (this.overWriteColorCheckBoxContainer.classList.contains("w3-disabled") == true) {
				this.overWriteColorCheckBoxContainer.classList.remove("w3-disabled");
			}
		} else {
			if (this.overWriteColorCheckBoxContainer.classList.contains("w3-disabled") == false) {
				this.overWriteColorCheckBoxContainer.classList.add("w3-disabled");
			}
		}
		this._onValueChange_colorPicker();
	}
	_onShow_dlg() {
		if (this.setOverWriteColor == false){
			this.overWriteColorCheckBox.setValue(false);
		}else{
			this.overWriteColorCheckBox.setValue(true);
		}
	}

}

export default mdsWidget(DayEditDialogForm);
